import p from 'prop-types'
import React from 'react'
import { Marker } from 'react-leaflet'
import leaflet from 'leaflet'
import { Maplet } from 'common/Maplet'
import { PoiTypePicker } from './PoiTypePicker'
import styles from './PoiMap.scss'
import { getIcon } from 'common/Map/POI'

export class PoiMap extends React.PureComponent {
  static propTypes = {
    bounds: p.object,
    center: p.array,
    onBoundsChange: p.func.isRequired,
    onLatLngChange: p.func.isRequired,
    onPoiTypeIdChange: p.func.isRequired,
    latLng: p.object,
    poiTypeId: p.number
  }

  constructor (props) {
    super(props)
    this.state = {
      showTypePicker: !!props.latLng
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line
    if (!this.props.latLng && nextProps.latLng) {
      this.setState({ showTypePicker: true })
    }
  }

  onMapClick = (click) => {
    if (!this.state.showTypePicker && !this.props.latLng) {
      this.setState({ showTypePicker: true })
    }
    this.props.onLatLngChange(click.latlng)
  }

  onMarkerClick = () => {
    this.setState({ showTypePicker: true })
  }

  onMarkerMoveEnd = (event) => {
    this.props.onLatLngChange(event.target.getLatLng())
  }

  onTypeIconClick = (poiTypeId) => {
    this.setState({ showTypePicker: false })
    this.props.onPoiTypeIdChange(poiTypeId)
  }

  render () {
    const { onBoundsChange, center, bounds, latLng, poiTypeId } = this.props
    const { showTypePicker } = this.state
    const icon = poiTypeId && getIcon(poiTypeId)
    const viewport = bounds ? { bounds } : { lastCenter: center, lastZoom: 15 }

    return (
      <div className={styles.mapContainer}>
        <Maplet
          routes={[]}
          {...viewport}
          onBoundsChange={onBoundsChange}
          onMapClick={this.onMapClick}
          scrollWheelZoom>
          {latLng && <Marker
            position={latLng}
            draggable
            icon={leaflet.icon(icon)}
            onClick={this.onMarkerClick}
            onMoveEnd={this.onMarkerMoveEnd} />}
          {showTypePicker && <PoiTypePicker onTypeSelected={this.onTypeIconClick} />}
        </Maplet>
        {!latLng &&
          <div className={styles.clickOnMapInstruction}>
            Click anywhere on the map to set a location
          </div>}
      </div>
    )
  }
}
